export default `
mutation forgotPassword($email:String!) { 
    forgotPassword(email:$email){ 
            ok
    }
}
`;
